import React from 'react';

import { Link } from 'react-router-dom';
import classNames from 'classnames';

const colors = {
  indigo:
    'bg-indigo-100 dark:bg-indigo-500/30 text-indigo-600 dark:text-indigo-400',
  sky: 'bg-sky-100 dark:bg-sky-500/30 text-sky-600 dark:text-sky-400',
  emerald:
    'bg-emerald-100 dark:bg-emerald-400/30 text-emerald-600 dark:text-emerald-400',
  amber: 'bg-amber-100 dark:bg-amber-400/30 text-amber-600 dark:text-amber-400',
  rose: 'bg-rose-100 dark:bg-rose-500/30 text-rose-500 dark:text-rose-400',
  blue: 'bg-blue-100 dark:bg-blue-500/30 text-blue-600 dark:text-blue-500',
  slate: 'bg-slate-100 dark:bg-slate-300 text-slate-500 dark:text-slate-600',
  dark: 'bg-slate-700 text-slate-100 dark:text-slate-400',
  yellow:
    'bg-yellow-100 dark:bg-yellow-500/30 text-yellow-700 dark:text-yellow-400',
};

export default function Badge({ color = 'indigo', text, link }) {
  if (!text) {
    return null;
  }

  return (
    <div
      className={classNames(
        'text-xs inline-flex font-medium rounded-full text-center px-2.5 py-1',
        colors[color],
        {
          'cursor-pointer': link,
        }
      )}
    >
      {link ? <Link to={link}>{text}</Link> : text}
    </div>
  );
}
